export default __webpack_public_path__ + "static/media/Eslint.895093d4.svg";